<script setup lang="ts">
/********************
 * PROPS & EMITS     *
 ********************/
export interface CiUserAvatarProps {
  bgClass?: string;
  border?: boolean;
  lightTheme?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  userImage?: string;
}
const props = withDefaults(defineProps<CiUserAvatarProps>(), {
  bgClass: '',
  border: false,
  lightTheme: false,
  size: 'md',
  userImage: '',
});

const imageClasses = computed(() => {
  const classes = ['relative', 'block', 'rounded-full'];

  if (props.border) {
    classes.push('border-[5px]', 'border-white');
  }

  switch (props.size) {
    case 'sm':
      classes.push('w-6', 'h-6');
      break;
    case 'lg':
      classes.push('w-[3.25rem]', 'h-[3.25rem]');
      break;
    case 'xl':
      classes.push('w-[4.75rem]');
      break;
    case 'md':
    default:
      classes.push('w-8', 'h-8');
      break;
  }

  return classes;
});
</script>

<template>
  <div class="relative">
    <div class="relative">
      <img
        v-if="props.userImage"
        :src="userImage"
        :class="imageClasses"
        alt="user image"
      />
      <img
        v-else-if="props.lightTheme"
        :class="[...imageClasses, props.bgClass]"
        src="~/assets/svg/user_placeholder.svg"
        alt="user image placeholder"
        width="52"
        height="52"
      />
      <img
        v-else
        :class="[...imageClasses, props.bgClass]"
        src="~/assets/svg/user_placeholder.grey.svg"
        alt="user image placeholder"
        width="52"
        height="52"
      />
    </div>
  </div>
</template>
